module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى عائلتي الحبيبة وقُرَّائي الأعزَّاء!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هذا الكتاب هو تجسيدٌ لروح العطاء والإلهام الذي منحتموني إيَّاهم عبر رحلتي الطويلة في عالم الكتابة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى عائلتي الغالية.. الداعمة.. قوَّتي وسندي وأملي الدائم!")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتم روح نجاحي ووقود إصراري")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وإلى كل قُرَّائي الأعزَّاء الذين أتمنَّى أن يكونوا عنوانًا دائمًا للإلهام والتحفيز!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أرسل إليكم امتناني العميق على دعمكم المستمر وردود فعلكم القيِّمة على كتابي الأول")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أهدي لكم هذا العمل بكلِّ حبٍّ واحترام، عسى أن يكون نقطة تواصُل بين قلوبنا وأفكارنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتمنَّى أن تجدوا في صفحاته البهجة والسرور")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دُمتم في حفظ الله ورعايته."), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-252de6bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 66
// module chunks = 0